export const SET_LOCALE = '@@i18n/SET_LOCALE';
export const setLocale = lang => ({
  type: SET_LOCALE,
  lang
});
